import { OperatorType } from '../../types/Operator';

export function isValidOperator(operator: string, validOperators: OperatorType[]): operator is OperatorType {
    return validOperators.some(validOperator => validOperator === operator);
}
